import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagenation',
  templateUrl: './pagenation.component.html',
  styleUrls: ['./pagenation.component.scss']
})
export class PagenationComponent {

  @Input() totalPages: number = 0;  // total number of pages
  @Input() currentPage: number = 1; // current page
  @Output() pageChange = new EventEmitter<number>(); // Emit page change event

  onPageChange(page: number) {
    this.pageChange.emit(page);
  }

  getPages(): (number | string)[] {
    const pages: (number | string)[] = [];
    const total = this.totalPages;
    const current = this.currentPage;

    if (total <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= total; i++) {
        pages.push(i);
      }
    } else {
      // Always show first 3 pages
      pages.push(1, 2, 3);

      if (current > 5) {
        pages.push('...');
      }

      // Show pages around current page if not near the start or end
      const start = Math.max(4, current - 1);
      const end = Math.min(total - 3, current + 1);

      for (let i = start; i <= end; i++) {
        if (i > 3 && i < total - 2) {
          pages.push(i);
        }
      }

      if (current < total - 4) {
        pages.push('...');
      }

      // Always show last 3 pages
      pages.push(total - 2, total - 1, total);
    }

    return pages;
  }

}
